// frontend/src/components/common/AmbassadorCart.js
import React from 'react';
import { fmt } from './CommonComponents';

function AmbassadorCart({ cartItems, onUpdateQuantity, onRemoveItem, onSubmit, submitting, id }) {
  const totalAmount = cartItems.reduce((sum, item) => sum + (item.price * item.quantity), 0);
  const totalItems = cartItems.reduce((sum, item) => sum + item.quantity, 0);

  if (cartItems.length === 0) {
    return (
      <div className="card" style={{ textAlign: "center", padding: 32, color: "var(--text-3)" }}>
        <div style={{ fontSize: 48, marginBottom: 12 }}>🛒</div>
        <p>Your cart is empty</p>
        <p style={{ fontSize: 12 }}>Browse products and add items to create an order request</p>
      </div>
    );
  }

  return (
    <div className="card" id={id}>
      <h2>🛒 Order Cart ({totalItems} item{totalItems !== 1 ? "s" : ""})</h2>
      
      <div className="table-wrap">
        <table className="w-full">
          <thead>
            <tr>
              <th>Product</th>
              <th>Location</th>
              <th style={{ textAlign: "center" }}>Qty</th>
              <th style={{ textAlign: "right" }}>Price</th>
              <th style={{ textAlign: "right" }}>Subtotal</th>
              <th style={{ width: 50 }}></th>
            </tr>
          </thead>
          <tbody>
            {cartItems.map(item => (
              <tr key={item.cartKey||item.productId}>
                <td style={{ fontWeight: 600 }}>{item.name}</td>
                <td style={{ fontSize:11 }}>{item.shopName||"Central"}</td>
                <td style={{ textAlign: "center" }}>
                  <input
                    type="number"
                    min="1"
                    max={item.stock}
                    value={item.quantity}
                    onChange={e => onUpdateQuantity(item.cartKey||item.productId, parseInt(e.target.value) || 1)}
                    style={{ width: 60, padding: "4px 6px", border: "1px solid var(--border)", borderRadius: 4, textAlign: "center" }}
                  />
                </td>
                <td style={{ textAlign: "right" }}>{fmt(item.price)}</td>
                <td style={{ textAlign: "right", fontWeight: 600 }}>{fmt(item.price * item.quantity)}</td>
                <td style={{ textAlign: "center" }}>
                  <button className="btn-sm btn-reject" onClick={() => onRemoveItem(item.cartKey||item.productId)}>✕</button>
                </td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr style={{ background: "var(--surface2)" }}>
              <td colSpan="4" style={{ textAlign: "right", fontWeight: 700 }}>Total:</td>
              <td style={{ textAlign: "right", fontWeight: 800, color: "var(--accent)" }}>{fmt(totalAmount)}</td>
              <td></td>
            </tr>
          </tfoot>
        </table>
      </div>
      
      <div style={{ marginTop: 16, display: "flex", gap: 10, justifyContent: "flex-end" }}>
        <button className="btn btn-primary" onClick={onSubmit} disabled={submitting}>
          {submitting ? "Submitting..." : "📤 Submit Sale Request"}
        </button>
      </div>
      
      <div className="alert alert-info" style={{ marginTop: 12, fontSize: 11 }}>
        💡 Your checkout is routed by fulfillment location. Each shop manager confirms only that shop's items; Central confirms only Central stock.
      </div>
    </div>
  );
}

export default AmbassadorCart;